module.exports = __webpack_public_path__ + "static/moon-7be878ba3b467ee1ca9f53d13eaba155.png";